const MODULE = 'WORK_OPERATION_DETAILS'
export const ADD = `${MODULE}/ADD`
export const FETCH_DETAILS_REQUEST = `${MODULE}/FETCH_DETAILS_REQUEST`
export const FETCH_DETAILS_SUCCESS = `${MODULE}/FETCH_DETAILS_SUCCESS`
export const FETCH_DETAILS_FAILED = `${MODULE}/FETCH_DETAILS_FAILED`
